import React from 'react';
import "./HorizontalLine.css"
export function HorizontalLinePrimary(props) {
    return (
        <div className={"hline_primary"}/>
    );
}


export function HorizontalLineSecondary(props) {
    return (
        <div className={"hline_secondary"}/>
    );
}

